var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScythe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M549.836 0H338.852C191.986 0 63.996 64 0 192H509.963L549.836 0ZM632.58 11.625C626.58 4.25 617.455 0 607.957 0H582.459L522.713 288H415.971C398.299 288 383.973 302.326 383.973 320S398.299 352 415.971 352H509.463L480.215 493C479.34 497.75 480.59 502.5 483.715 506.25C486.715 509.875 491.215 512 495.965 512H527.463C535.086 512 541.711 506.5 543.086 499L639.453 38C641.203 28.625 638.703 19 632.58 11.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScythe);
export default __webpack_public_path__ + "static/media/scythe.95335b8009d262919942992dec789e89.svg";
export { ForwardRef as ReactComponent };